
import { types, actions } from './requests'
export const CLEARPARENT_TYPES = {
    ...types('CLEARPARENT'),
}
export const CLEARPARENT_ACTIONS = {
    ...actions('CLEARPARENT'),
}